import axios from 'axios';
// Create an Axios instance with the base URL
const apiClient = axios.create({
  baseURL: 'https://rib.sriyansh.co.in',
  timeout: 100000, // optional, sets a timeout for requests
  headers: {
    'Content-Type': 'application/json', // optional, set default headers
  },
});

// Request interceptor to handle additional configurations
apiClient.interceptors.request.use(
  (config) => {
    // Add Authorization token if needed
    // const token = localStorage.getItem('authToken'); // example token storage
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    return config;
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  }
);

// Response interceptor to handle responses globally
apiClient.interceptors.response.use(
  (response) => {
    // Handle successful responses
    return response;
  },
  (error) => {
    // Handle errors globally
    if (error.response) {
      // Server responded with a status other than 2xx
      console.error('Response error:', error.response.data);
    } else if (error.request) {
      // No response received
      console.error('No response from server:', error.request);
    } else {
      // Other errors
      console.error('Error setting up request:', error.message);
    }
    return Promise.reject(error);
  }
);

export default apiClient;
